const formatHourMinuteLabel = (hour, min) => {
  const suffix = hour >= 12 ? "PM" : "AM";
  const displayHour = hour % 12 === 0 ? 12 : hour % 12;
  return `${displayHour}:${min} ${suffix}`;
};

export const TIME_OPTIONS = Array.from({ length: 24 * 2 }, (_, i) => {
  const hour = Math.floor(i / 2);
  const min = i % 2 === 0 ? "00" : "30";
  return {
    value: `${hour}.${min}`,
    label: formatHourMinuteLabel(hour, min),
  };
});

export const formatStoredTime = (time) => {
  if (!time) return "";
  const [hours, minutes] = String(time).split(".");
  const hour = parseInt(hours, 10);
  const min = (minutes || "00").padStart(2, "0");
  const suffix = hour >= 12 ? "PM" : "AM";
  const displayHour = hour % 12 === 0 ? 12 : hour % 12;
  return `${displayHour}:${min} ${suffix}`;
};
